"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.millisecondsBetweenTimeStamps = void 0;
function millisecondsBetweenTimeStamps(first, second) {
    return Math.abs(new Date(first).getTime() - new Date(second).getTime());
}
exports.millisecondsBetweenTimeStamps = millisecondsBetweenTimeStamps;
